import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";

import AcceptUserModal from "../components/AcceptUserModal";
import RejectUserModal from "../components/RejectUserModal";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import TablePagination from "@mui/material/TablePagination";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import PropTypes from "prop-types";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function PendingRequests() {
  const [listOfPendingRequests, setListOfPendingRequests] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    axios.get(process.env.REACT_APP_ADMIN_URL).then((res) => {
      if (res.data !== null) {
        res.data.map((user) => {
          if (!user.enabled) {
            setListOfPendingRequests((listOfPendingRequests) => [
              ...listOfPendingRequests,
              user,
            ]);
            return;
          } else {
          }
        });
      }
    });
  }, []);

  return (
    <div>
      <Navbar />
      <Sidebar />

      <div className=" h-10 bg-white mx-24 text-gray-500 flex rounded justify-start pl-2 align-middle mt-4">
        <h1 style={{ fontSize: 25 }}>Pending User Registration Requests</h1>
      </div>

      <div className="h-12 bg-white mx-24 flex text-gray-500 rounded justify-start pl-2 align-middle mt-4">
        <p className="description-paragraph">
          As one of the CM Admin you can accept or reject a user's registration
          request. Users' requests can be managed equally by an other CM Admin
          in the same manner.
        </p>
      </div>

      <div className="flex flex-col bg-white mt-4 mx-24 rounded">
        <h3 className="font-bold text-3xl text-gray-500 pl-2">
          List of Pending User Registration Requests
        </h3>{" "}
        <hr className="container-hr" />
        <div className="table">
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
            colSpan={5}
            count={listOfPendingRequests.length}
            rowsPerPage={rowsPerPage}
            page={page}
            sx={{ float: "right" }}
            SelectProps={{
              inputProps: {
                "aria-label": "rows per page",
              },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />

          <TableContainer component={Paper} sx={{ height: "800px" }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{
                      maxWidth: 100,
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Username
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      maxWidth: 100,
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Role
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      maxWidth: 100,
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Type
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Requested At{" "}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Actions
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  ></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? listOfPendingRequests
                      .sort(function (a, b) {
                        return a.createdTimestamp < b.createdTimestamp ? 1 : -1;
                      })
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                  : listOfPendingRequests.sort(function (a, b) {
                      return a.createdTimestamp < b.createdTimestamp ? 1 : -1;
                    })
                ).map((user) => {
                  if (!user.enabled) {
                    return (
                      <TableRow
                        key={user.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          align="center"
                          scope="row"
                          sx={{
                            maxWidth: 200,
                            maxHeight: 10,
                            wordBreak: "break-all",
                          }}
                        >
                          {user.username}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ maxWidth: 200, wordBreak: "break-all" }}
                        >
                          {user.email}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ maxWidth: 200, wordBreak: "break-all" }}
                        >
                          {user.attributes.role}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ maxWidth: 200, wordBreak: "break-all" }}
                        >
                          {user.attributes.type}
                        </TableCell>

                        <TableCell align="center">
                          {moment(user.createdTimestamp).format(
                            "DD-MM-YYYY HH:mm:ss"
                          )}
                        </TableCell>
                        <TableCell align="center" sx={{ marginLeft: "120px" }}>
                          <div className="pending-actions-buttons">
                            <RejectUserModal user={user} />
                            <AcceptUserModal user={user} />
                          </div>
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    );
                  }
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
            colSpan={3}
            count={listOfPendingRequests.length}
            rowsPerPage={rowsPerPage}
            page={page}
            sx={{ float: "right" }}
            SelectProps={{
              inputProps: {
                "aria-label": "rows per page",
              },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </div>
      </div>
    </div>
  );
}
